import { IUserSearchResultsData, IUserSearchResultsAction } from 'models/search/usersearchresults';
import { IStore } from 'redux/IStore';
import { IPage, IEntityDto } from 'models/common';
import { IUserListItem } from 'models/user/userlistitem';
import { IUserCard } from 'models/user/usercard';
import { IUserPreferences } from 'models/user/userpreferences';
import { IFollowingItem } from 'models/common';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';

/** Action Types */
export const REQUEST_START: string = 'userssearchresults/REQUEST_START';
export const REQUEST_FAILURE: string = 'userssearchresults/REQUEST_FAILURE';
export const GET_USERS_SUCCESS: string = 'userssearchresults/GET_USERS_SUCCESS';
export const SET_ITEMS_PAGE: string = 'userssearchresults/SET_ITEMS_PAGE';
export const RESET_DATA: string = 'userssearchresults/RESET_DATA';
export const RESET_SEARCH_DATA: string = 'userssearchresults/RESET_SEARCH_DATA';
export const RESET_FILTERS: string = 'userssearchresults/RESET_FILTERS';
export const SET_LANGUAGE_FILTER: string = 'userssearchresults/SET_LANGUAGE_FILTER';
export const GET_SELECTED_SEARCHED_USER_SUCCESS: string = 'userssearchresults/GET_SELECTED_SEARCHED_USER_SUCCESS';
export const FOLLOW_ITEM_SUCCESS: string = 'userssearchresults/FOLLOW_ITEM_SUCCESS';
export const SET_PAGINGDATA: string = 'userssearchresults/SET_PAGINGDATA';
export const SET_KEYWORD: string = 'userssearchresults/SET_KEYWORD';

/** Initial State */
const initialState: IUserSearchResultsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	keyword: null,
	sortOrder: null,
	selectedSearchedUser: null,
};

/** Reducer */
export function userSearchResultsReducer(state = initialState, action: IUserSearchResultsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_USERS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case SET_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				sortOrder: null,
				selectedSearchedUser: null,
			});

		case RESET_SEARCH_DATA:
			return Object.assign({}, state, {
				items: [],
				isFetching: false,
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				sortOrder: null,
				selectedSearchedUser: null,
				keyword: null,
			});

		case FOLLOW_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case GET_SELECTED_SEARCHED_USER_SUCCESS:
			return Object.assign({}, state, {
				selectedSearchedUser: action.payload.selectedSearchedUser,
				isFetching: false,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getUserSearchResults(isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const url = 'api/User/Search';

		const currentPage: number = getState().userSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().userSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword && keyword !== '') {
			queryString = queryString + '&keyword=' + keyword;
		}

		queryString = queryString + '&CurrentPage=' + newPage;
		queryString = queryString + '&ItemsPerPage=' + itemsPerPage;

		let currentPageItems: IUserListItem[] = [];

		return fetch(
			getState().fetchDefault.baseAPI + url + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res
						.json()
						.then((res: IPage) => {
							if (isFirstLoad) {
								dispatch(resetData());
							}
							const userProfiles: IUserListItem[] = getState().userSearchResults.items;
							const newProfiles: IUserListItem[] = res.items;
							currentPageItems = newProfiles;
							const allProfiles = userProfiles.concat(newProfiles);
							dispatch(setItemsPage(res));
							dispatch(getUsersSuccess(allProfiles));
							getUserFollowing(allProfiles);
						})
						.then(() => {
							const userPreferences: IUserPreferences = getState().userPreferences;
							if (userPreferences && userPreferences.id) {
								dispatch(getUserFollowing(currentPageItems));
							}
						});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch((err) => {
							console.warn(err);
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				console.warn(err);
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getUserInfluencersProfilesSearchResults(isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const url = 'api/User/Search';

		const currentPage: number = getState().userSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().userSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword && keyword !== '') {
			queryString = queryString + '&keyword=' + keyword;
		}

		queryString = queryString + '&CurrentPage=' + newPage;
		queryString = queryString + '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + url + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						const userProfiles: IUserListItem[] = getState().userSearchResults.items;
						const newProfiles: IUserListItem[] = res.items;
						dispatch(setItemsPage(res));
						dispatch(getUsersSuccess(userProfiles.concat(newProfiles)));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getUserFollowing(users: IUserListItem[]) {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(requestStart());

		const items: IEntityDto[] = users.map((item) => {
			return {
				entityId: item.entityId,
			};
		});

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(items),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(updateItemsWithFollow(res)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateItemsWithFollow(followingItems?: IFollowingItem[]) {
	return (dispatch, getState: () => IStore) => {
		const items: IUserListItem[] = [...(getState().userSearchResults.items || [])];

		if (followingItems !== null) {
			followingItems.map((followingItem: IFollowingItem) => {
				const item: IUserListItem = items.filter((i) => i.entityId === followingItem.key.entityId)[0];
				const itemIndex = items.indexOf(item);
				item.following = followingItem.value;
				items[itemIndex] = item;
			});
		} else {
			items.map((item) => {
				item.following = false;
			});
		}

		dispatch(getUsersSuccess(items));
	};
}

/** Action Creator */
export function followUser(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateFollowedUser(itemId, undefined));
		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + itemId + '/Follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(updateFollowedUser(itemId, true));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowUser(itemId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateFollowedUser(itemId, undefined));
		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/' + itemId + '/Follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(updateFollowedUser(itemId, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateFollowedUser(id: string, following: boolean | undefined) {
	return (dispatch, getState: () => IStore) => {
		const items: IUserListItem[] = [...(getState().userSearchResults.items || [])];
		const itemInList: IUserListItem = items.filter((x) => JSON.parse(x.entityId).id === id)[0];
		const itemIndex = items.indexOf(itemInList);
		if (itemIndex >= 0) {
			const previous = items[itemIndex].following;
			if (previous === following) {
				return;
			}
			if (following === undefined) {
				items[itemIndex] = {
					...items[itemIndex],
					following,
				};
			} else {
				items[itemIndex] = {
					...items[itemIndex],
					following,
					followersCount: items[itemIndex].followersCount + (following ? 1 : -1),
				};
			}
		}

		dispatch(getUsersSuccess(items));
	};
}

/** Action Creator */
export function getSelectedSearchedUser(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IUserCard) => {
						dispatch(getSelectedSearchedUserSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IUserSearchResultsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getUsersSuccess(items: IUserListItem[]): IUserSearchResultsAction {
	return {
		type: GET_USERS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IUserSearchResultsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IUserSearchResultsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IUserSearchResultsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function resetSearchData(): IUserSearchResultsAction {
	return {
		type: RESET_SEARCH_DATA,
	};
}
/** Action Creator */
export function setUserSearchKeyword(keyword: string): IUserSearchResultsAction {
	return {
		type: SET_KEYWORD,
		payload: {
			keyword,
		},
	};
}

/** Action Creator */
export function getSelectedSearchedUserSuccess(selectedSearchedUser: IUserListItem): IUserSearchResultsAction {
	return {
		type: GET_SELECTED_SEARCHED_USER_SUCCESS,
		payload: {
			selectedSearchedUser,
		},
	};
}
